import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Building2, Mail, Loader2, CheckCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import API_BASE from '../../utils/apiBase';

const API = API_BASE;

export default function ClientLoginPage() {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error('Enter your work email');
      return;
    }
    setSending(true);
    try {
      const res = await fetch(`${API}/client/request-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
      if (res.ok) {
        setSent(true);
        toast.success('Check your email for the login link');
      } else {
        // Public sign-in errors never expose provider-specific account data.
        toast.error('Could not send link right now. Please try again later.');
      }
    } catch {
      toast.error('Could not send link right now. Please try again later.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-950 via-emerald-900 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl overflow-hidden">
        <div className="bg-emerald-800 px-6 py-8 text-center text-white">
          <Building2 className="h-10 w-10 mx-auto mb-3 opacity-90" />
          <h1 className="text-xl font-bold">CareDock</h1>
          <p className="text-emerald-100 text-sm mt-2">For care homes &amp; commissioners</p>
        </div>
        <div className="p-6">
          {sent ? (
            <div className="text-center py-4">
              <CheckCircle className="h-12 w-12 text-emerald-600 mx-auto mb-4" />
              <p className="font-medium text-slate-900">Login link sent</p>
              <p className="text-sm text-slate-600 mt-2">Check <strong>{email}</strong> and click the link. It expires in 24 hours.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <p className="text-sm text-slate-600">
                See your upcoming agency staff, site clock-in status, and invoices.
              </p>
              <div className="space-y-2">
                <Label htmlFor="email">Your work email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="manager@carehome.co.uk"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="h-12 text-base"
                />
              </div>
              <Button type="submit" className="w-full h-12 bg-emerald-700 hover:bg-emerald-800" disabled={sending}>
                {sending ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" />Sending…</> : <><Mail className="h-4 w-4 mr-2" />Email me a login link</>}
              </Button>
            </form>
          )}
          <p className="text-xs text-slate-500 text-center mt-6">
            Use the email your care provider invited. Contact your organisation if you need help.
          </p>
        </div>
      </div>
      <p className="absolute bottom-4 text-xs text-white/50">
        <Link to="/" className="hover:text-white">CareDock</Link>
      </p>
    </div>
  );
}